import { render, staticRenderFns } from "./TrainerCard.vue?vue&type=template&id=43780442&scoped=true&"
import script from "./TrainerCard.vue?vue&type=script&lang=js&"
export * from "./TrainerCard.vue?vue&type=script&lang=js&"
import style0 from "./TrainerCard.vue?vue&type=style&index=0&id=43780442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43780442",
  null
  
)

export default component.exports